const requestWakeLock = async () => {
    try {
      const wakeLock = await navigator.wakeLock.request('screen');
    } catch (err) {
      // the wake lock request fails - usually system related, such low as battery
      console.log(`${err.name}, ${err.message}`);
    }
  }
export default requestWakeLock